import type { ProjectDependencyScope, ReleaseGroupDependencyScope } from '../../../../shared/dependenciesV2';

export type InventoryScope = ProjectDependencyScope | ReleaseGroupDependencyScope;

export const checkProjectScope = (scope: InventoryScope): scope is ProjectDependencyScope => scope.scope === 'project';
export const checkReleaseGroupScope = (scope: InventoryScope): scope is ReleaseGroupDependencyScope => scope.scope === 'releaseGroup';

export type InventoryDependencyIsLoading = {
  any: boolean;
  managed: boolean;
  snippets: boolean;
  vendored: boolean;
  binary: boolean;
};

export type InventoryDependencyCounts = {
  total: number;
  managed: number | null;
  vendored: number | null;
  snippets: number | null;
  binary: number | null;
};

export type UseInventoryDependencyCountsResult = {
  isLoading: InventoryDependencyIsLoading;
  counts: InventoryDependencyCounts;
};

export type UseInventoryFeaturesResult = {
  /**
   * If we should show the Inventory dropdown with multiple features
   */
  shouldShowInventory: boolean;
  /**
   * If we should show the Snippets feature
   */
  shouldShowSnippets: boolean;
  /**
   * If we should show the Binary Analysis feature
   */
  shouldShowBinaryAnalysis: boolean;
  /**
   * If we should show the Vendored dependencies feature
   */
  shouldShowVendored: boolean;
};

export type EnhancedScanFeaturesAvailableResult = {
  /**
   * If snippets are available across this set of projectTypes
   */
  areSnippetsAvailable: boolean;
  /**
   * If vendored dependencies are available across this set of projectTypes
   */
  areVendoredDependenciesAvailable: boolean;
  /**
   * If binary analysis is available across this set of projectTypes
   */
  isBinaryAnalysisAvailable: boolean;
  /**
   * If the features enabled support possibly showing the inventory UI
   * NOTE: does NOT take into account the projectTypes, based solely on feature flags
   */
  isInventoryUIFeatureEnabled: boolean;
};
